import { encodeURI } from "../helpers/formatters";

export const getAvailableHardwares = (licenseId) => {
  return {
    url: `/api/LicenseAssigment/Hardwares?licenseId=${licenseId}`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
};

export const getBindRequest = (licenseId, hardwareId) => {
  return {
    url: encodeURI(
      `/api/LicenseAssigment/Bind?licenseId=${licenseId}&hardwareId=${encodeURIComponent(hardwareId)}`
    ),
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
};

export const getUnbindRequest = (licenseId) => {
  return {
    url: `/api/LicenseAssigment/Unbind?licenseId=${licenseId}`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
};

export const getDeleteHardwareRequest = (hardwareId) => {
  return {
    url: `/api/LicenseAssigment?hardwareId=${encodeURIComponent(hardwareId)}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json"
    },
  };
};